import CreateScreen from './create';

const routes = [
  {
    path: '/shipment/activation/:id',
    component: CreateScreen,
    action: ['manage'],
    service: ['nvo.tms.shipment'],
  },
];

export default routes;
